module.exports = __webpack_public_path__ + "static/media/DL BACK.44843d59.jpg";